var _g, _rect, _defs, _setting;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group3 1",
    width: 237,
    height: 237,
    viewBox: "0 0 237 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      maxWidth: "100%",
      maxHeight: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.994 0.473877H0.474457V227.994H227.994V0.473877Z",
    stroke: "black",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,910.079345703125"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,910.079345703125;            0,455.0396728515625,455.0396728515625,0;            910.079345703125,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.1247 0.473877V227.994",
    stroke: "black",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,227.52012634277344"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,227.52012634277344;            0,113.76006317138672,113.76006317138672,0;            227.52012634277344,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.345 0.473877V227.994",
    stroke: "black",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,227.52012634277344"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,227.52012634277344;            0,113.76006317138672,113.76006317138672,0;            227.52012634277344,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.234 0.473877V227.994",
    stroke: "black",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,227.52012634277344"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,227.52012634277344;            0,113.76006317138672,113.76006317138672,0;            227.52012634277344,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.663086 152.344H228.183",
    stroke: "black",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,227.51991271972656"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,227.51991271972656;            0,113.75995635986328,113.75995635986328,0;            227.51991271972656,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.663086 76.1247H228.183",
    stroke: "black",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,227.51991271972656"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,227.51991271972656;            0,113.75995635986328,113.75995635986328,0;            227.51991271972656,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.663086 114.234H228.183",
    stroke: "black",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,227.51991271972656"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,227.51991271972656;            0,113.75995635986328,113.75995635986328,0;            227.51991271972656,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.474457 0.473877L227.994 227.994",
    stroke: "black",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,321.7616271972656"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,321.7616271972656;            0,160.8808135986328,160.8808135986328,0;            321.7616271972656,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.474457 227.994L227.994 0.473877",
    stroke: "black",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,321.7616271972656"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,321.7616271972656;            0,160.8808135986328,160.8808135986328,0;            321.7616271972656,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.234 161.634C140.413 161.634 161.634 140.412 161.634 114.234C161.634 88.0555 140.413 66.8339 114.234 66.8339C88.0562 66.8339 66.8345 88.0555 66.8345 114.234C66.8345 140.412 88.0562 161.634 114.234 161.634Z",
    stroke: "black",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,297.86456298828125"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,297.86456298828125;            0,148.93228149414062,148.93228149414062,0;            297.86456298828125,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.234 209.034C166.591 209.034 209.034 166.59 209.034 114.234C209.034 61.8773 166.591 19.4339 114.234 19.4339C61.8779 19.4339 19.4345 61.8773 19.4345 114.234C19.4345 166.59 61.8779 209.034 114.234 209.034Z",
    stroke: "black",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,595.7290649414062"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,595.7290649414062;            0,297.8645324707031,297.8645324707031,0;            595.7290649414062,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.074 38.7735H38.3945C27.9231 38.7735 19.4345 47.2622 19.4345 57.7335V171.493C19.4345 181.965 27.9231 190.453 38.3945 190.453H190.074C200.546 190.453 209.034 181.965 209.034 171.493V57.7335C209.034 47.2622 200.546 38.7735 190.074 38.7735Z",
    stroke: "black",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,650.0247192382812"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,650.0247192382812;            0,325.0123596191406,325.0123596191406,0;            650.0247192382812,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.499 29.2935H47.9693C37.4456 29.2935 28.9145 37.8245 28.9145 48.3483V180.878C28.9145 191.402 37.4456 199.933 47.9693 199.933H180.499C191.023 199.933 199.554 191.402 199.554 180.878V48.3483C199.554 37.8245 191.023 29.2935 180.499 29.2935Z",
    fill: "#FF00FF",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,649.8615112304688"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,649.8615112304688;            0,324.9307556152344,324.9307556152344,0;            649.8615112304688,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.3945 38.7735V190.453C38.3945 200.925 46.8831 209.413 57.3545 209.413H171.114C181.586 209.413 190.074 200.925 190.074 190.453V38.7735C190.074 28.3022 181.586 19.8135 171.114 19.8135H57.3545C46.8831 19.8135 38.3945 28.3022 38.3945 38.7735Z",
    stroke: "black",
    strokeWidth: 0.1,
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,650.0247192382812"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,650.0247192382812;            0,325.0123596191406,325.0123596191406,0;            650.0247192382812,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 237,
    stroke: "black",
    strokeDasharray: "0,0,0,948"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "XML",
    attributeName: "stroke-dasharray",
    repeatCount: 1,
    dur: "2.1739130434782608s",
    values: "0,0,0,948;            0,474,474,0;            948,0,0,0",
    keyTimes: "0; 0.5; 1",
    fill: "freeze"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_580",
    x: 0.424454,
    y: 0.423874,
    width: 227.758,
    height: 231.62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1_580"
  })))), _setting || (_setting = /*#__PURE__*/React.createElement("setting", null, "{\"type\":\"direct\",\"speed\":23,\"random\":1,\"shift\":1,\"size\":1,\"rupture\":50}")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.3510bd522efff80854a17fb7df680190.svg";
export { ForwardRef as ReactComponent };